import { useState } from "react";
// STYLES
import * as Style from "./EditUserStatusStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { ButtonTypes, NewcomeUserStatus, SnackbarTypes } from "models/GeneralTypes/generalTypes";
import { IModalData } from "../../ModalAtomModel";
import { IProps } from "./EditUserStatusModel";
import { IUsersApiParams } from "models/interfaces";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { modalProps, toggleModalState, toggleSnackbarState } from "slices/uiSlice";
import { usersFilters } from "slices/userSlice";
import { addToBlackList, changeUserStatusVerified, getAllUsers, removeFromBlacklist } from "api/userApi";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";



const EditUserStatus = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const usersFiltersValue = useAppSelector<IUsersApiParams>(usersFilters);
  const modalData = useAppSelector<IModalData>(modalProps);
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS
  const [editUserState, setEditUserState] = useState("")

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleVerifyUser = () => {
    setEditUserState("verify");
  };

  const handleBlockUser = () => {
    setEditUserState("block");
  };

  const handleUnblockUser = () => {
    setEditUserState("unblock")
  }

  const handlePressYes = () => {
    if (editUserState === "verify") {
      dispatch(changeUserStatusVerified(modalData?.user?.id))
        .then(() => {
          dispatch(getAllUsers(usersFiltersValue))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                })
              );
            })
          setEditUserState("")
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.VERIFY_SUCCESS,
            item: t("snackbar.user")
          }))
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    } else if (editUserState === "block") {
      dispatch(addToBlackList(modalData?.user?.id))
        .then(() => {
          dispatch(getAllUsers(usersFiltersValue))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                })
              );
            })
          setEditUserState("")
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.BLOCK_SUCCESS,
            item: t("snackbar.user")
          }))
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    } else if (editUserState === "unblock") {
      dispatch(removeFromBlacklist(modalData?.user?.id))
        .then(() => {
          dispatch(getAllUsers(usersFiltersValue))
            .then(() => {
              dispatch(
                toggleModalState({
                  ...modalData,
                  isVisible: false,
                  type: "",
                })
              );
            })
          setEditUserState("")
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.UNBLOCK_SUCCESS,
            item: t("snackbar.user")
          }))
        })
        .catch((error) => {
          console.log(error)
          dispatch(toggleSnackbarState({
            isVisible: true,
            type: SnackbarTypes.SUPPORT_ERROR,
          }))
        })
    }
  };

  const handlePressNo = () => {
    setEditUserState("")
  };

  return (
    <Style.ConfirmationModalContainer>
      <Style.CloseIcon onClick={handleClose} />
      {editUserState === "" ?
        <Style.HeaderContainer>
          {t("modal.editUserStatus.title")}
        </Style.HeaderContainer> :
        <Style.HeaderContainer>
          {t("modal.editUserStatus.confirm")}
        </Style.HeaderContainer>
      }
      {editUserState === "" ? <Style.ButtonsWrapper>
        <ButtonAtom
          onClick={handleVerifyUser}
          text={t("modal.editUserStatus.verifyBtn")}
          type={modalData?.user?.userStatus !== NewcomeUserStatus.VERIFIED ?   ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.DISABLED}
          width="160px"
        />
        <ButtonAtom
          onClick={modalData?.user?.userStatus !== NewcomeUserStatus.BLACKLIST ? handleBlockUser : handleUnblockUser}
          text={modalData?.user?.userStatus !== NewcomeUserStatus.BLACKLIST ? t("modal.editUserStatus.blockBtn") : t("modal.editUserStatus.unblockBtn")}
          type={ButtonTypes.SECONDARY_BUTTON_DEFAULT}
          width="160px"
        />
      </Style.ButtonsWrapper> :
        <Style.ButtonsWrapper>
          <ButtonAtom
            onClick={handlePressYes}
            text={t("modal.editUserStatus.yes")}
            type={ButtonTypes.SECONDARY_BUTTON_DEFAULT}
            width="160px"
          />
          <ButtonAtom
            onClick={handlePressNo}
            text={t("modal.editUserStatus.no")}
            type={ButtonTypes.THIRD_BUTTON}
            width="160px"
          />
        </Style.ButtonsWrapper>
      }
    </Style.ConfirmationModalContainer>
  );
};

export default EditUserStatus;
